import React, {useEffect} from 'react';

const HsForms = ({formId}) => {

    useEffect(() => {
        const script = document.createElement('script');
        script.src='https://js.hsforms.net/forms/shell.js';
        document.body.appendChild(script);

        script.addEventListener('load', () => {
            if (window.hbspt) {
                window.hbspt.forms.create({
                    region: "na1",
                    portalId: "8853360",
                    formId: formId,
                    target: '#hubspotForm',
                    
                })
            }
        });
    }, []);

    return <div id="hubspotForm"></div>
}

export default HsForms;
